<script>
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import ApiListingItem from "@core/components/common/expression-language/ApiListingItem.vue";

export default {
    components: {AppCollapse, ApiListingItem, AppCollapseItem},
    props: {
        explanation: {
            required: true
        }
    },
}
</script>

<template>
    <div>
        <AppCollapse accordion type="margin">
            <AppCollapseItem :title="explanation.context.description || explanation.context.key">
                <ApiListingItem :module="explanation.context"/>
            </AppCollapseItem>
            <AppCollapseItem :title="explanation.subject.description || explanation.subject.key">
                <ApiListingItem :module="explanation.subject"/>
            </AppCollapseItem>
            <AppCollapseItem :title="module.description || module.key" v-for="module in explanation.modules">
                <ApiListingItem :module="module"/>
            </AppCollapseItem>
        </AppCollapse>
    </div>
</template>
